export const initialState = {
    searchQuery: '',
    filter: 'all',
}